export const brl = (value) => {
  if (value == null) return "Sob consulta";
  try {
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 }).format(value);
  } catch {
    return `R$ ${value}`;
  }
};

export const priceRange = (prices) => {
  if (!prices) return "Sob consulta";
  const vals = Object.values(prices);
  const min = Math.min(...vals);
  const max = Math.max(...vals);
  return `${brl(min)} – ${brl(max)}`;
};
